// import { useContext, useEffect, useState } from "react";
// import { useForm } from "react-hook-form";
// import { SidebarContext } from "context/SidebarContext";
// import { notifyError, notifySuccess } from "utils/toast";
// import { overRideMarginServices } from "services/marginServices";

// const defaultValues = {
//     city_name: "",
//     margin: {},
// };

// const formatDateLocal = (date) => {
//     if (!(date instanceof Date)) return null;

//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");

//     return `${year}-${month}-${day}`;
// };

// const useOverrideMarginSubmit = (id) => {
//     const {
//         isDrawerOpen,
//         closeDrawer,
//         setIsUpdate,
//     } = useContext(SidebarContext);

//     const [loading, setLoading] = useState(false);
//     const [isSubmitting, setIsSubmitting] = useState(false);

//     const [marginData, setMarginData] = useState(null);

//     const [selectedCity, setSelectedCity] = useState(null);

//     const [startDate, setStartDate] = useState(null);
//     const [endDate, setEndDate] = useState(null);

//     const handleStartDateChange = (date) => {
//         setStartDate(date);
//     };

//     const {
//         register,
//         handleSubmit,
//         setValue,
//         reset,
//         clearErrors,
//         trigger,
//         formState: { errors },
//     } = useForm({
//         defaultValues,
//     });

//     const clearForm = () => {
//         reset(defaultValues);

//         clearErrors();

//         setMarginData(null);

//         setSelectedCity(null);

//         setStartDate(null);

//         setEndDate(null);
//     };

//     // const getOverrideMarginDetails = async () => {
//     //     try {
//     //         clearForm();

//     //         const res =
//     //             await overRideMarginServices.getOverRideMarginByCity(id);

//     //         const data = res?.data;

//     //         if (!data) return;

//     //         setMarginData(data);

//     //         setSelectedCity(data.id_city);

//     //         setValue("city_name", data.city_name || "");

//     //         if (data.start_date) {
//     //             setStartDate(new Date(data.start_date));
//     //         }

//     //         if (data.end_date) {
//     //             setEndDate(new Date(data.end_date));
//     //         }

//     //         Object.entries(data.margin_details || {}).forEach(
//     //             ([vehicleId, vehicle]) => {
//     //                 setValue(`margin.${vehicleId}`, vehicle.fee);
//     //             }
//     //         );
//     //     } catch (err) {
//     //         notifyError(
//     //             err?.response?.data?.message ||
//     //             err?.message ||
//     //             "Something went wrong"
//     //         );
//     //     }
//     // };

// const getOverrideMarginDetails = async () => {
//   try {
//     const res = await overRideMarginServices.getOverRideMarginBySingleId(id);

//     const data = res.data;

//     setMarginData(data);

//     setSelectedCity(data.id_city);

//     setValue("city_name", data.city_name);

//     setStartDate(
//       data.start_date ? new Date(data.start_date) : null
//     );

//     setEndDate(
//       data.end_date ? new Date(data.end_date) : null
//     );

//     Object.entries(data.margin || {}).forEach(([vehicleId, fee]) => {
//       setValue(`margin.${vehicleId}`, fee);
//     });

//   } catch (err) {
//     notifyError(
//       err?.response?.data?.message ||
//       err?.message ||
//       "Something went wrong"
//     );
//   }
// };

//     const onSubmit = async (data) => {

//         console.log(data,'here is the data on the jjkjkjkjkjkjkjkjjjjjjj')
//         setLoading(true);
//         setIsSubmitting(true);

//         try {
//             const margin = {};
//             const vehicle_type = [];

//             Object.entries(data.margin || {}).forEach(
//                 ([vehicleId, value]) => {
//                     if (
//                         value !== "" &&
//                         value !== undefined &&
//                         value !== null
//                     ) {
//                         vehicle_type.push(String(vehicleId));

//                         margin[vehicleId] = Number(value);
//                     }
//                 }
//             );

//             const payload = {
//                 id_city: selectedCity,
//                 vehicle_type,
//                 start_date: formatDateLocal(startDate),
//                 end_date: formatDateLocal(endDate),
//                 margin,
//                 is_active: 1,
//             };

//             let response;

//             if (id) {
//                 response =
//                     await overRideMarginServices.updateOverRideMarginById(
//                         id,
//                         payload
//                     );
//             } else {
//                 response =
//                     await overRideMarginServices.addOverRideMargin(
//                         payload
//                     );
//             }

//             notifySuccess(response.message);

//             setIsUpdate(true);

//             closeDrawer();
//         } catch (err) {
//             notifyError(
//                 err?.response?.data?.message ||
//                 err?.message ||
//                 "Something went wrong"
//             );
//         } finally {
//             setLoading(false);
//             setIsSubmitting(false);
//         }
//     };

//     useEffect(() => {
//         if (!isDrawerOpen) {
//             clearForm();
//             return;
//         }

//         if (id) {
//             getOverrideMarginDetails();
//         } else {
//             clearForm();
//         }
//     }, [id, isDrawerOpen]);

//     return {
//         register,
//         trigger,
//         handleSubmit,
//         onSubmit,

//         loading,
//         isSubmitting,

//         errors,

//         marginData,

//         selectedCity,
//         setSelectedCity,

//         startDate,
//         endDate,
//         setEndDate,
//         handleStartDateChange,
//     };
// };

// export default useOverrideMarginSubmit;

import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { SidebarContext } from "context/SidebarContext";
import { notifyError, notifySuccess } from "utils/toast";
import { itineraryOverRideMarginServices } from "services/marginServices";

const defaultValues = {
  city_name: "",
  margin: {},
};

const formatDateLocal = (date) => {
  if (!(date instanceof Date)) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const useItineraryPeriodicMarginSubmit = (id) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    clearErrors,
    trigger,
    unregister,
    formState: { errors },
  } = useForm({
    defaultValues,
  });

  const [loading, setLoading] = useState(false);
  const [marginData, setMarginData] = useState(null);

  const [selectedCity, setSelectedCity] = useState(null);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && date > endDate) {
      setEndDate("");
    }
  };

  //-------------------------------------------------------
  // Clear Form
  //-------------------------------------------------------

  const clearForm = () => {
    reset(defaultValues);

    clearErrors();

    unregister("margin");

    setMarginData(null);

    setSelectedCity(null);

    setStartDate(null);

    setEndDate(null);

    setValue("margin", {});
  };

  //-------------------------------------------------------
  // Edit API
  //-------------------------------------------------------

  const getOverrideMarginDetails = async () => {
    try {
      clearForm();

      const response =
        await itineraryOverRideMarginServices.getOverRideMarginBySingleId(id);

      const data = response?.data;

      if (!data) return;

      setMarginData(data);

      setSelectedCity(data.id_city);

      setValue("city_name", data.city_name || "");

      setStartDate(data.start_date ? new Date(data.start_date) : null);

      setEndDate(data.end_date ? new Date(data.end_date) : null);

      Object.entries(data.margin || {}).forEach(([vehicleId, margin]) => {
        setValue(`margin.${vehicleId}`, margin);
      });
    } catch (err) {
      notifyError(
        err?.response?.data?.message || err?.message || "Something went wrong",
      );
    }
  };

  //-------------------------------------------------------
  // Submit
  //-------------------------------------------------------

  const onSubmit = async (data) => {
    try {
      setLoading(true);

      const margin = {};
      const vehicle_type = [];

      Object.entries(data.margin || {}).forEach(([vehicleId, value]) => {
        if (value !== "" && value !== undefined && value !== null) {
          vehicle_type.push(String(vehicleId));

          margin[vehicleId] = Number(value);
        }
      });

      const payload = {
        id_city: selectedCity,
        vehicle_type,
        start_date: formatDateLocal(startDate),
        end_date: formatDateLocal(endDate),
        margin,
        is_active: 1,
      };

      let response;

      if (id) {
        response =
          await itineraryOverRideMarginServices.updateOverRideMarginById(
            id,
            payload,
          );
      } else {
        response =
          await itineraryOverRideMarginServices.addOverRideMargin(payload);
      }

      notifySuccess(response.message);

      setIsUpdate(true);

      clearForm();

      closeDrawer();
    } catch (err) {
      notifyError(
        err?.response?.data?.message || err?.message || "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };

  //-------------------------------------------------------
  // Drawer Open / Close
  //-------------------------------------------------------

  useEffect(() => {
    if (!isDrawerOpen) {
      clearForm();
      return;
    }

    if (id) {
      getOverrideMarginDetails();
    } else {
      clearForm();
    }
  }, [id, isDrawerOpen]);

  //-------------------------------------------------------
  // Return
  //-------------------------------------------------------

  return {
    register,
    trigger,
    handleSubmit,
    onSubmit,

    errors,
    loading,

    marginData,

    selectedCity,
    setSelectedCity,

    startDate,
    endDate,

    setEndDate,
    handleStartDateChange,

    setValue,
    unregister,
    clearForm,
  };
};

export default useItineraryPeriodicMarginSubmit;
